import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';
import {
  actionLoadGridDataRequest,
  actionLoadGridDataSuccess,
  actionLoadGridDataFail,
} from 'react-redux-app/lib/modules/grid/actions';
import { actionAddAffiliatePrograms } from '../../affiliateProgram/actions/affiliateProgram';
import { actionAddCampaigns } from './campaigns';

import { CAMPAIGNS_GRID_NAME } from '../constants';
import { CAMPAIGNS_SCHEMA } from '../schemas';

import { removeBlankFields } from 'react-redux-app/lib/modules/core/utils';
import { getGridFilter } from '../utils';


export const actionLoadCampaignsRequest = () => (
  (dispatch, getState, { apiClientHelper, history: { location } }) => {
    dispatch(actionLoadGridDataRequest(CAMPAIGNS_GRID_NAME));

    const filter = getGridFilter(location);

    return apiClientHelper.get(
      '/rest/webmaster/campaign',
      { params: removeBlankFields(filter) },
      CAMPAIGNS_SCHEMA
    ).then(
      ({ entities, result }) => {
        dispatch(actionAddAffiliatePrograms(entities.affiliatePrograms));
        dispatch(actionAddCampaigns(entities.campaigns));

        dispatch(actionLoadGridDataSuccess(
          CAMPAIGNS_GRID_NAME, result.items, result.count, result.summary
        ));
      },
      error => {
        dispatch(actionLoadGridDataFail(CAMPAIGNS_GRID_NAME, error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
